export { default } from './hero'
